export { default } from './hero'
